<template>
  <svg
    class="star"
    version="1.1"
    width="14"
    height="16"
    role="img"
    aria-label="Stars"
  ><path
    fill-rule="evenodd"
    d="M14 6l-4.9-.64L7 1 4.9 5.36 0 6l3.6 3.26L2.67 14 7 11.67 11.33 14l-.93-4.74L14 6z"
  /></svg>
</template>

<script>
  export default {
    name: 'StarSvg',
  }
</script>

<style>
  .star {
    vertical-align: bottom;
    display: inline-block;
    height: 1.2em;
    width: 1.2em;
  }
</style>
